var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 47.7L128.85 219L65.25 155.4L86.4 134.25L128.85 176.7L278.85 26.7L300 47.7ZM266.85 123.3C268.8 131.85 270 140.85 270 150C270 216.3 216.3 270 150 270C83.7 270 30 216.3 30 150C30 83.7 83.7 30 150 30C173.7 30 195.6 36.9 214.2 48.75L235.8 27.15C211.5 10.05 181.95 0 150 0C67.2 0 0 67.2 0 150C0 232.8 67.2 300 150 300C232.8 300 300 232.8 300 150C300 132.15 296.7 115.05 291 99.15L266.85 123.3Z",
    fill: "#5CB338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckImg);
export default __webpack_public_path__ + "static/media/checkImg.c6d4ba79aacbfc052170000b24a0cf2b.svg";
export { ForwardRef as ReactComponent };